var map = {
	"./arabic.json": 826,
	"./bulgarian.json": 827,
	"./czech.json": 828,
	"./denmark.json": 829,
	"./english.json": 830,
	"./finnish.json": 831,
	"./greek.json": 832,
	"./indonesian.json": 833,
	"./malay.json": 834,
	"./norwegian.json": 835,
	"./romanian.json": 836,
	"./slovakia.json": 837,
	"./swedish.json": 838,
	"./thai.json": 839
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2478;


//////////////////
// WEBPACK FOOTER
// ./src/locales/apps4all [A-Za-z0-9-_,\s]+\.json$/
// module id = 2478
// module chunks = 0